import { Observable } from 'rxjs';

import type {
  PaymentQr,
  PaymentQrCreateInput,
  PaymentQrListFilter,
  PaymentQrPage,
} from '@app/domain/models/payments-qr/payment-qr.model';

/**
 * Port del cobro con QR (`/api/v1/payments/qr/`).
 *
 * Separado de `PolipayPaymentsRepository` a propósito (§SOLID-I): Links, Cargos,
 * Resumen y Comercios no dependen de estas operaciones.
 *
 * Contrato de error: toda implementación falla con `PaymentQrError` — nunca con
 * un `HttpErrorResponse` ni con el cuerpo del backend.
 */
export abstract class PaymentQrRepository {
  /** `POST qr/`. La `idempotencyKey` viaja tal cual en el header `Idempotency-Key`. */
  abstract create(input: PaymentQrCreateInput, idempotencyKey: string): Observable<PaymentQr>;
  /** `GET qr/`. */
  abstract list(filter: PaymentQrListFilter): Observable<PaymentQrPage>;
  /** `GET qr/<id_qr>/` — el detalle viene reconciliado con la pasarela. */
  abstract getById(idQr: number): Observable<PaymentQr>;
  /** `POST qr/<id_qr>/cancel/` — solo `Pending`; en otro estado falla con `conflict`. */
  abstract cancel(idQr: number): Observable<PaymentQr>;
}
